export default __webpack_public_path__ + "static/media/top_w576down_4.0d9fb793.png";